import { StyleSheet, Dimensions } from 'react-native';

const styles = StyleSheet.create({
  chatRoot: {
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
  },
  messagesScroll: {
    flex: 1,
    minHeight: 0,
    maxHeight: Dimensions.get('window').height * 0.7
  },
  messagesContent: {
    paddingBottom: 10,
    flexGrow: 1,
  },
  container: {
    backgroundColor: '#CDD7DC',
    flex: 1,
    borderRadius: 10,
    flexDirection: 'row',
    paddingTop: 10,
    marginBottom: 10,
    justifyContent: 'center',
  },
  inputBar: {
    backgroundColor: '#CDD7DC',
    borderRadius: 10,
    flexDirection: 'row',
    flexShrink: 0,
    paddingTop: 10,
    marginBottom: 10,
    justifyContent: 'center',
  },
  icon: {
    color: "#0453A9"
  },
  textInput: {
    backgroundColor: '#F8F8F8',
    color: '#A1A1A1',
    margin: 30,
    padding: 10,
    flex: 0.9,
    borderRadius: 12,
  },
  attachments:{
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 40
  },
  sendBtn: { marginTop: 40 }
});

export default styles;
